/**
 * Pump owner role detection from API role fields (role_name, role_slug, is_owner).
 * Matches "owner" slug/name and legacy labels such as "pump owner" or "proprietor".
 */
export const isOwnerRole = (roleNameOrSlug) => {
  if (roleNameOrSlug && typeof roleNameOrSlug === "object") {
    if (roleNameOrSlug.is_owner === true) {
      return true;
    }
    const slug = String(roleNameOrSlug.role_slug || "").trim().toLowerCase();
    if (slug === "owner") {
      return true;
    }
    return isOwnerRole(roleNameOrSlug.role_name);
  }

  const normalized = String(roleNameOrSlug || "").trim().toLowerCase();
  if (normalized === "owner") {
    return true;
  }
  // Legacy pumps may expose display name only (e.g. "Owner").
  if (normalized === "pump owner" || normalized === "proprietor") {
    return true;
  }

  return false;
};
